
import React from 'react';
import ReactLoading from 'react-loading';

const Loading = () =>
{
    return (
        <ReactLoading type='spinningBubbles' color='#c88025' height={'10%'} width={'10%'} />
    )
}

export default Loading